const IconButton = ({ LeftIcon, RightIcon, label, onClick, className, ...props }) => {
  return (
    <button className={`flex items-center ${className}`} onClick={onClick} {...props}>
      {LeftIcon}
      <span className="select-none">{label}</span>
      {RightIcon}
    </button>
  );
};

export { IconButton };
